/*eslint-disable max-len*/
export default {
  Error: {
    UAuthError: {
      8: '用户已存在',
      9: '缺失必填信息',
      10: '用户名不正确',
      11: '发送邀请失败',
      12: '令牌不正确或已失效',
      13: '登陆信息错误'
    }
  },

  Form: {
    Toolbar: {
      Continue: '继续',
      Cancel: '取消',
      Edit: '编辑',
      Delete: '删除',
      DelModal: {
        Header: '删除项目',
        Body: '你确定你要永久删除当前项目吗? 确认点击继续，离开点击取消.'
      }
    },
    Actions: {
      Add: '添加',
      Save: '保存',
      Cancel: '取消',
      Close: '返回',
      Ok: '完成'
    },
    Validations: {
      Required: '必填',
      Invalid: '无效值',
      InvalidRegion: '无效地区',
      InvalidEmail: '错误邮件格式',
      MaxLen: '最大字符长度不能超过{0}',
      MinLen: '需要最少{0}个字符',
      InvalidNum: '只能填写数字',
      ZeroOrMore: '只能填写大于等于0的数字',
      MoreThanZero: '只能填写大于0的数字',
    }
  },

  ConfirmModal: {
    Continue: '继续',
    Cancel: '取消'
  },

  RegionPicker: {
    region: '地区',
    command: '命令'
  },

  MemberBadge: {
    External: '外部用户',
    Internal: '内部用户'
  },

  MemberOption: {
    member_since: '加入时间:',
    already_in_group: '已经是组成员',
  },

  Login: {
    Username: '用户名',
    Password: '密码',
    Submit: '登录',
    timeOutPanel: {
      header: '如果您保持非活动状态，您的线上状态将过期。',
      body: '您的帐户将自动退出',
      unit: '秒'
    },
    sessionTimeOutError: '您的在线已过期',
    continueSessionText: '继续',
    missingInput: '请输入用户名和密码',

    apiResponseErrors: {
      401: '凭证无效',
      400: '验证失败'
    }
  },

  ForgotPassword: {
    link: '忘记密码?',
    title: '忘记密码',
    email: '邮件',
    Send: '发送',
    Close: '返回',
    Processing: '处理中...',
    InvalidEmail: '系统无法处理您的新密码请求，输入的电子邮件地址无效',
    RequestSent: '您的请求已成功处理'
  },

  Home: {
    title: '应用程序主页',
    modules: {
      UBLT: '批量上传工具 (UBLT)',
      UBET: '批量解压工具 (UBET)',
      UFLOW: '案例管理 (UFLOW)',
      USERMNG: '用户管理'
    }
  },

  Editor: {
    theme: '样式主题'
  },

  ContentPermission: {
    NoBLTRolesFound: '您没有访问任何Unity应用程序所需的权限。 请与<a href="mailto:UnitySupportTeam@DNB.com?subject=Unity Access Request"> Unity支持小组联系</a>，说明您要访问的市场。',
    WelcomeMessage: '欢迎来到Unity'
  },

  Footer: {
    Terms: '条款',
    PrivacyPolicy: '保密协议',
    Copyright: '© 邓白氏商业信息咨询有限公司 {0}版权所有.'
  },

  Header: {
    settings: '设置',
    logout: '注销',
    title: 'Unity',
    options: '选择',
    reader: '邓白氏Unity',
    wiki: '维基（帮助）'
  },

  MultiStep: {
    nextButton: '下一步',
    previousButton: '上一步',
    nextTextOnFinalActionStep: '保存'
  },

  FileInput: {
    placeHolder: '选择文件'
  },

  menuLinks: {
    main: '门户主页',
    UBET: '批量解压工具 (UBET)',
    UBET_tabs: {
      launcher: '启动'
    },
  },

  SearchGrid: {
    messageSearch: '搜索..',
    messageSearching: '搜索中...',
    messageLoadMore: '滚动以载入更多记录',
    messageNoMatches: '没有记录匹配您的查询'
  },

  UBET: {
    linkText: '点击这里打开 UBET (新窗口)'
  },

}
